import { Avatar, Box, Typography, Button } from '@mui/material';

type User = {
  id: number;
  email: string;
  name?: string | null;
  mediaThumbnail: string;
};

export const BlockedUserItem = ({
  user,
  onUnblock,
}: {
  user: User;
  onUnblock: () => void;
}) => {
  return (
    <Box className="flex justify-between bg-white p-4 rounded-[10px]">
      <Box className="flex justify-center items-center gap-2.5">
        <Avatar
          alt={'profilePicture'}
          src={user.mediaThumbnail}
          data-testid="avatar"
          className="self-center"
        />
        <Box className="flex flex-col justify-center gap-2">
          {user.name && (
            <Typography
              variant="h6"
              className="text-gray-1 text-[16px] font-extrabold"
            >
              {user.name}
            </Typography>
          )}
          <Typography className="text-gray-4">{user.email}</Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        className="h-[36px] self-center"
        onClick={onUnblock}
      >
        Unblock user
      </Button>
    </Box>
  );
};
